import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * A one-line note about a campaign, set off by a rule on its left: the turnover caveat under a
 * task, the bet feedback over the overlay's dock panel. `urgent` for what the player should act on
 * now — the rule turns `--urgent` and the note is announced (`role="status"`).
 */
export const CampaignNotice = ({
  tone = "info",
  className,
  children,
}: {
  tone?: "info" | "urgent";
  className?: string;
  children: ReactNode;
}) => (
  <p
    role={tone === "urgent" ? "status" : undefined}
    className={cn(
      "flex flex-wrap items-baseline gap-x-1 border-l-2 pl-2 font-body text-[12px] leading-[18px] text-foreground-secondary",
      tone === "urgent" ? "border-urgent" : "border-primary",
      className
    )}
  >
    {children}
  </p>
);
